import CustomDrawer from "ui/Drawer"
import PropTypes from "prop-types"
import GroupDropdown from "../../ClientWindow/GroupManager"
import { useTranslation } from "react-i18next"
import { Button, Flex } from "antd"
import { useDispatch, useSelector } from "react-redux"
import { SyncBulkGroup } from "store/clients"

const SyncGroupDrawer = ({
  title,
  open,
  setOpen,
  groupAction,
  isMenuListHide,
  selectedClient,
  selectedClientIds,
  groups,
  setIsGroupModalVisible,
  selectedGroups,
  handleSelectedGroupsChange,
  setSelectedClientIds,
  removeGroups,
  handleFetchClients,
  setSelectedClient,
  setGroupAction,
  setIsMenuListHide,
  setSelectedGroups
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { loading } = useSelector((state) => state.clients.groupClients)

  const handleCancelGroupAction = () => {
    setIsGroupModalVisible(false)
    setSelectedClient(null)
    setGroupAction("")
    setIsMenuListHide(false)
    setSelectedClientIds([])
    setSelectedGroups([])
    handleFetchClients()
    setOpen(false)
  }

  const handleGroupActionClick = async () => {
    try {
      await dispatch(
        SyncBulkGroup({
          client_ids: selectedClientIds,
          group_ids: selectedGroups.map((group) => group.group_id),
          remove_group_ids: removeGroups.map((group) => group.group_id)
        })
      )
      handleCancelGroupAction()
    } catch (error) {
      console.error("Failed to bulk add client groups:", error)
    }
  }

  return (
    <CustomDrawer title={title} open={open} setOpen={setOpen} size="large" footer={null}>
      <GroupDropdown
        action={groupAction}
        menuState={true}
        isMenuListHide={isMenuListHide}
        client={selectedClient}
        selectedClientIds={selectedClient ? undefined : selectedClientIds}
        groups={groups}
        setIsGroupModalVisible={setIsGroupModalVisible}
        selectedGroups={selectedClient?.client_groups || selectedGroups || []}
        onSelectedGroupsChange={handleSelectedGroupsChange}
        moduleName={"client"}
        setSelectedClientIds={setSelectedClientIds}
        groupAction={groupAction}
      />
      <Flex gap={12} className="my-xl" vertical>
        <Button type="primary" onClick={handleGroupActionClick} loading={loading}>
          {t("global.save")}
        </Button>
        <Button variant="outlined" color="primary" onClick={handleCancelGroupAction}>
          {t("global.cancel")}
        </Button>
      </Flex>
    </CustomDrawer>
  )
}

SyncGroupDrawer.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  groupAction: PropTypes.string,
  isMenuListHide: PropTypes.bool,
  selectedClient: PropTypes.object,
  selectedClientIds: PropTypes.array,
  groups: PropTypes.array,
  setIsGroupModalVisible: PropTypes.func,
  selectedGroups: PropTypes.array,
  handleSelectedGroupsChange: PropTypes.func,
  setSelectedClientIds: PropTypes.func,
  removeGroups: PropTypes.arrayOf(PropTypes.object),
  handleFetchClients: PropTypes.func,
  setSelectedClient: PropTypes.func,
  setGroupAction: PropTypes.func,
  setIsMenuListHide: PropTypes.func,
  setSelectedGroups: PropTypes.func
}

export default SyncGroupDrawer
